<template>
  <v-card
      v-if="isPaymentSlipValueAvailable"
      flat
      column>
    <v-subheader>
      Boleto
    </v-subheader>

    <v-card
        flat
        class="ml-3 px-4 py-2"
        color="grey lighten-5">
      <v-layout column>
        <v-flex class="mt-3 mb-3">
          <v-layout row justify-space-between align-center class="grey--text">
            <span class="text-uppercase">Taxa</span>
            <strong class="headline">{{ paymentSlipValue.value.tax }}</strong>
          </v-layout>
        </v-flex>
        <v-flex class="mt-3 mb-3">
          <v-layout row justify-space-between align-center class="grey--text">
            <span class="text-uppercase">Análise</span>
            <strong class="headline">{{ paymentSlipValue.value.analysis }}</strong>
          </v-layout>
        </v-flex>
        <v-flex class="mt-3 mb-3">
          <v-layout class="total" row justify-space-between align-center>
            <span class="text-uppercase">Total enquadrado</span>
            <strong class="display-1">
              {{ paymentSlipValue.value.total }}
            </strong>
          </v-layout>
        </v-flex>
        <v-flex class="mt-3 mb-3">
          <v-layout class="total" row justify-space-between align-center>
            <span class="text-uppercase">Você Pagará</span>
            <strong class="display-1">
              {{ paymentSlipValue.value.you_will_pay }}
            </strong>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card>

  </v-card>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import {isEmpty} from 'lodash';

import TypologyService from "@/services/applications/configurations/TypologyService";
import ApplicationService from "@/services/applications/ApplicationService";

export default {
  name: 'ResumePaymentSlip',
  data() {
    return {
      paymentSlipValue: {},
    };
  },
  methods: {
    ...mapActions('newApplication', ['setEnvironmentalStudyTypeRequired']),
    async calculatePaymentSlip() {
      this.$store.dispatch('setLoadingDialog', false)

      // try {
      const typologyId = this.newApplication.frameworkEntity.typology.id
      const technicalParameters = this.newApplication.frameworkEntity.technicalParametersFilled

      let environmentalStudyTypeRequired;

      console.log(this.applicationType)

      // LAC não tem estudo ambiental
      if (this.applicationType.applicationTypeSelected.acronym === 'LAC') {

        this.setEnvironmentalStudyTypeRequired(null)
      } else {
        environmentalStudyTypeRequired = await TypologyService.fetchEnviromentalStudyTypeRequired(typologyId, technicalParameters)

      }

      this.setEnvironmentalStudyTypeRequired(environmentalStudyTypeRequired)
      const analysisTypeId = isEmpty(environmentalStudyTypeRequired) ? null : environmentalStudyTypeRequired.analysis_type_id;

      const payload = {
        applicationTypeId: this.applicationType.applicationTypeSelected.id,
        degradingPotentialForTaxId: this.frameworkEntity.degradingPotentialForTax.id,
        sizeForTaxId: this.frameworkEntity.sizeForTax.id,
        analysisType: analysisTypeId,
        isSocialInterest: this.applicationType.isSocialInterest,
        isProcessReanalysis: this.applicationType.isProcessReanalysis,
        isOwnershipChange: this.applicationType.isOwnershipChange,
        qualifyForLac: this.applicationType.qualifyForLac,
        enquadramento: this.entity.enquadramento
      }

      ApplicationService
          .fetchPaymentSlipValue(payload)
          .then((response) => {
            this.paymentSlipValue = response.data
          })
          .finally(() => this.$store.dispatch('setLoadingDialog', false))

      // } catch (e) {
      //   this.$swal({
      //     title: 'Erro',
      //     text: "Erro ao calcular valor do boleto. Verifique se todos os dados foram preenchidos corretamente",
      //     type: 'error',
      //     showConfirmButton: 'Ok',
      //   });
      // }

    },
  },
  computed: {
    ...mapGetters('newApplication', ['step', 'newApplication']),
    isPaymentSlipValueAvailable() {
      return !isEmpty(this.paymentSlipValue)
    },
    applicationType() {
      return this.newApplication.applicationType;
    },
    frameworkEntity() {
      return this.newApplication.frameworkEntity;
    },
    entity() {
      return this.newApplication.entity;
    },

  },
  watch: {
    step(newValue) {
      if (newValue && newValue === 6) {
        this.calculatePaymentSlip()
      }
    }
  }
};
</script>
